import * as React from 'react';
import {useDispatch} from 'react-redux';
import {getType} from 'typesafe-actions';
import {BackButton} from '../../components/BackButton';
import {Animation} from '../../components/ui/Animation';
import {backButtonAction} from '../../store/actions';
import {useCurrentState} from '../MachineProvider/useCurrentService';
import styles from './BackButtonContainer.scss';
import {IOuter} from './BackButtonContainer.types';

export const BackButtonContainer: React.FunctionComponent<IOuter> = () => {
  const state = useCurrentState();
  const dispatch = useDispatch();
  const handleClick = () => dispatch(backButtonAction());

  if (!state.nextEvents.includes(getType(backButtonAction))) {
    return null;
  }

  return (
    <Animation animationKey="backButton">
      <div className={styles.backButtonContainer}>
        <BackButton onClick={handleClick} />
      </div>
    </Animation>
  );
};

BackButtonContainer.displayName = 'BackButtonContainer';
